(function () {
  var KEY = 'geo_cur_dismissed_at';
  var TTL = 14 * 24 * 60 * 60 * 1000; // 14 days

  function dismissed() {
    try { var t = parseInt(localStorage.getItem(KEY), 10); return t && (Date.now() - t) < TTL; }
    catch (e) { return false; }
  }
  function remember() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }

  function show(iso, m) {
    var el = document.getElementById('geo-cur-prompt');
    if (!el || !m) return;
    document.getElementById('geo-cur-text').textContent =
      "You're in " + m.n + " — shop in " + m.c + "?";
    document.getElementById('geo-cur-switch').textContent = 'Shop in ' + m.c;

    // Pre-set the target country NOW (before any click) so the native localization form
    // POSTs the right country_code — avoids a submit-timing race with Shopify's own handler.
    document.getElementById('geo-cur-country').value = iso;
    document.getElementById('geo-cur-form').addEventListener('submit', remember);
    document.getElementById('geo-cur-close').addEventListener('click', function () {
      remember();
      el.classList.remove('is-visible');
    });

    el.classList.add('is-visible');
  }

  function init() {
    var markets = window.geoCurMarkets || {};
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || window.geoCurShop || 'USD';

    // TEST HOOK: ?geo_test=AU forces that market's banner (verify UI without an overseas IP). Harmless in prod.
    try {
      var test = new URLSearchParams(location.search).get('geo_test');
      if (test) { var t = test.toUpperCase(); if (markets[t]) show(t, markets[t]); return; }
    } catch (e) {}

    if (dismissed()) return;
    if (!window.Shopify || !window.Shopify.routes || !window.Shopify.country) return; // bail if globals absent
    var here = window.Shopify.country; // active market ISO, e.g. "US"
    var url = window.Shopify.routes.root + // survives localized roots (/en-au/ etc.)
      'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
      encodeURIComponent(here);

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var c = (data.detected_values && data.detected_values.country) ||
                (data.suggestions && data.suggestions[0] &&
                 data.suggestions[0].parts && data.suggestions[0].parts.country);
        if (!c || !c.handle) return;
        var iso = c.handle.toUpperCase();
        var m = markets[iso];
        if (!m) return;          // not a distinct-currency market (they're on the default) -> stay silent
        if (m.c === cur) return; // already shopping in that currency
        show(iso, m);
      })
      .catch(function () {}); // endpoint lightly documented; fail silent, never error
  }

  function deferRun(fn) {
    if ('requestIdleCallback' in window) { requestIdleCallback(fn, { timeout: 2500 }); }
    else { setTimeout(fn, 1200); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { deferRun(init); });
  } else { deferRun(init); }
})();
